module.exports = __webpack_public_path__ + "img/ddr3.d0a9f505.png";